<template>
    <div>
        <HeaderCard />
        <panel title="REGISTRASI BADAN USAHA" class="panel panel-dark">
            <b-card class="my-2 rounded-0">
                <b-button variant="primary" @click="backButton">
                    <i class="fa fa-arrow-circle-left"></i> Kembali
                </b-button>
            </b-card>
            <b-card class="rounded-0 shadow-md">
                <div class="nav-wizards-container">
                    <nav class="nav nav-wizards-2 mb-2">
                        <!-- completed -->
                        <div class="nav-item col">
                            <a href="#"
                                :class="{
                                    'nav-link': true,
                                    completed: completeVar.isComplete1,
                                }"
                            >
                                <div class="nav-text">
                                    1. PROFIL BADAN USAHA
                                </div>
                            </a>
                        </div>

                        <!-- active -->
                        <div class="nav-item col">
                            <a href="#"
                                :class="{
                                    'nav-link': true,
                                    completed: completeVar.isComplete2,
                                }"
                            >
                                <div class="nav-text">2. PIMPINAN</div>
                            </a>
                        </div>

                        <div class="nav-item col">
                            <a href="#"
                                :class="{
                                    'nav-link': true,
                                    completed: completeVar.isComplete3,
                                }"
                            >
                                <div class="nav-text">3. PENANGGUNG JAWAB</div>
                            </a>
                        </div>

                        <!-- <div class="nav-item col">
                            <a href="#"
                                :class="{
                                    'nav-link': true,
                                    completed: completeVar.isComplete4,
                                }"
                            >
                                <div class="nav-text">4. SELESAI</div>
                            </a>
                        </div> -->
                    </nav>
                </div>
            </b-card>
            <b-card class="my-2 rounded-0 shadow-md">
                <router-view></router-view>
            </b-card>
        </panel>
    </div>
</template>

<script>
/* eslint-disable */
// eslint-disable-next-line
// eslint-disable vue/no-unused-vars
// eslint-disable-line no-unused-vars
import HeaderCard from "@/components/header/HeaderCard.vue";
import { mapState } from 'vuex';

export default {
    components: {
        HeaderCard
    },
    data() {
        return {
            activeVar: {
                isActive1: false,
                isActive2: false,
            },
            completeVar: {
                isComplete1: false,
                isComplete1: false,
            },
            disabledVar: {
                isDisabled1: false,
                isDisabled2: false,
            }
        };
    },
    created() {
        this.stepClass();
    },
    computed: {
        // vuex state untuk npbu
        ...mapState([
            'Npbu'
        ])
    },
    watch: {
        $route(to, from) {
            this.stepClass();
        }
    },
    methods: {
        stepClass() {
            switch (this.$route.name) {
                case "EditNpbu1":
                case "StepNpbu1":
                    // jika step 1 complete
                    this.completeVar.isComplete1 = true;
                    this.completeVar.isComplete2 = false;
                    this.completeVar.isComplete3 = false;
                    this.completeVar.isComplete4 = false;
                    break;
                case "EditNpbu2":
                case "StepNpbu2":

                    // jika step 2 complete
                    this.completeVar.isComplete1 = true;
                    this.completeVar.isComplete2 = true;
                    this.completeVar.isComplete3 = false;
                    this.completeVar.isComplete4 = false;
                    break;
                case "EditNpbu3":
                case "StepNpbu3":
                    // jika step 2 complete
                    this.completeVar.isComplete1 = true;
                    this.completeVar.isComplete2 = true;
                    this.completeVar.isComplete3 = true;
                    this.completeVar.isComplete4 = false;
                    break;
                default:
                    // jika step 1 complete
                    this.completeVar.isComplete1 = false;
                    this.completeVar.isComplete2 = false;
                    this.completeVar.isComplete3 = false;
                    this.completeVar.isComplete4 = false;
            }
        },
        backButton () {
            localStorage.removeItem('npbu_id')
            this.$router.push({ name: "ListNpbu" })
        }
    }
};
</script>
